var exports = {
  "kL": "xfd349460--0bd3a0--container",
  "wm": "xfd349460--0bd3a0--logo",
  "yr": "xfd349460--0bd3a0--logo-image",
  "ot": "xfd349460--0bd3a0--logo-icon",
  "pq": "xfd349460--0bd3a0--info",
  "nf": "xfd349460--0bd3a0--link",
};

module.exports = exports;
